import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    type LazyComponent,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { GlobalSettingsAccountFolderNodeWithDummyList } from './components/GlobalSettingsAccountFolderNodeWithDummyList';
import onAccountAuthSucceeded from 'owa-account-source-list-store/lib/actions/onAccountAuthSucceeded';
import { configureNewPstAccount } from 'owa-pst-file-config/lib/actions/configureNewPstAccount';
import { remediatePendingPstAccount } from 'owa-pst-file-config/lib/actions/remediatePendingPstAccount';
import { remediatePstAccount } from 'owa-pst-file-config/lib/actions/remediatePstAccount';
import { showAccountConfigurationDialog } from 'owa-account-config/lib/actions/showAccountConfigurationDialog';
import type { AccountsTreeViewProps } from './components/AccountsTreeView';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "Accounts" */ './lazyIndex'),
    {
        name: 'Accounts',
    }
);

export const AccountsTreeView: LazyComponent<AccountsTreeViewProps, HTMLDivElement, void> =
    createLazyComponent(
        lazyModule,
        m => m.AccountsTreeView,
        GlobalSettingsAccountFolderNodeWithDummyList
    );

// Lazy orchestrators
registerLazyOrchestrator(
    onAccountAuthSucceeded,
    lazyModule,
    m => m.onAccountAuthSucceededOrchestrator
);

registerLazyOrchestrator(
    configureNewPstAccount,
    lazyModule,
    m => m.configureNewPstAccountOrchestrator
);
registerLazyOrchestrator(
    remediatePendingPstAccount,
    lazyModule,
    m => m.remediatePendingPstAccountOrchestrator
);
registerLazyOrchestrator(remediatePstAccount, lazyModule, m => m.remediatePstAccountOrchestrator);
registerLazyOrchestrator(
    showAccountConfigurationDialog,
    lazyModule,
    m => m.addNewAccountOrchestrator
);
